import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import img from '../assets/Images/patrick-tomasso-Oaqk7qqNh_c-unsplash.jpg';
import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';

// import { Blogs } from '../data/BlogData';
import { Projects } from '../data/projectData';
import BlogComponent from './BlogComponent';
import AnchorComponent from '../subComponents/Anchor';
import BigTitle from '../subComponents/BigTitlte';
import { motion } from 'framer-motion';
import '../index.css';
console.log(Projects);
const MainContainer = styled(motion.div)`
	background-size: cover;
	background-repeat: no-repeat;
	background-attachment: fixed;
	background-position: center;
`;
const Container = styled.div`
	background-color: ${(props) => `rgba(${props.theme.bodyRgba},0.8)`};
	width: 100%;
	height: auto;

	position: relative;
	padding-bottom: 5rem;
`;

const Center = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding-top: 10rem;
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(calc(10rem + 15vw), 1fr));
	grid-gap: calc(1rem + 2vw);
`;

// Framer-motion config
const container = {
	hidden: { opacity: 0 },
	show: {
		opacity: 1,

		transition: {
			staggerChildren: 0.5,
			duration: 0.5,
		},
	},
};

const ProjectsPage = () => {
	const [numbers, setNumbers] = useState(0);

	useEffect(() => {
		let num = (window.innerHeight - 70) / 30;
		setNumbers(parseInt(num));
	}, []);
	// const classs=`card_image ${card_image_}`;
	return (
		<MainContainer
			variants={container}
			initial="hidden"
			animate="show"
			exit={{
				opacity: 0,
				transition: { duration: 0.5 },
			}}
		>
			<Container>
				<LogoComponent />
				<PowerButton />
				{/* <SocialIcons /> */}
				{/* <AnchorComponent number={numbers} /> */}

				<ul className="cards">
					{Projects.map((project) => (
						<li className="cards__item">
							<div className="card">
								{/* <div className="card__image card__image--flowers"></div>
								 */}
								{/* <div className={project.card__image card__image}></div> */}
								<img src={project.imgSrc} style={{ height: '200px' }} alt="" />
								<div className="card__content">
									<div className="card__title">{project.name}</div>
									<div>
										{project.tags.map((tag, key) =>
											key == 0 ? (
												<span>
													<strong> {tag}</strong>
												</span>
											) : (
												<span>
													<strong> | {tag}</strong>
												</span>
											)
										)}
									</div>
									<p className="card__text">{project.dsc}</p>
									<p>
										<a
											href={project.LiveLink}
											target="_blank"
											style={{ textDecoration: 'none', color: 'black' }}
										>
											<strong>Live</strong>
										</a>{' '}
										<a
											href={project.GithubLink}
											target="_blank"
											style={{
												textDecoration: 'none',
												paddingLeft: '1rem',
												color: 'black',
											}}
										>
											<strong>Source Code</strong>
										</a>
									</p>
								</div>
							</div>
						</li>
					))}
				</ul>
				<BigTitle text="PROJECTS" top="3rem" left="5rem" />
			</Container>
		</MainContainer>
	);
};

export default ProjectsPage;
